<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    componentName: 'ElFormItem',
    name: 'nz-valid-reject',
    data(){
      return {};
    }
  }
</script>

// src/framework/components/base/valid-reject/src/nz-valid-reject.vue



// WEBPACK FOOTER //
// src/framework/components/base/valid-reject/src/nz-valid-reject.vue